import PropTypes from "prop-types"

/**
 * PropTypes for the Integrity SidebarSection component.
 *
 * @property {Object|null} selectedReport - Currently selected integrity report (null if no selection)
 * @property {Object} filters - Current filter state
 * @property {Function} onFilterChange - Filter change dispatcher
 * @property {number} visibleCount - Number of reports after filtering
 * @property {Function} onRunNow - Callback to trigger a fresh reconciliation run
 * @property {boolean} isRunning - Whether a reconciliation run is in progress
 * @property {boolean} canRunNow - Whether the current user may trigger a run
 */
export const integritySidebarSectionPropTypes = {
	selectedReport: PropTypes.object,
	filters: PropTypes.object.isRequired,
	onFilterChange: PropTypes.func.isRequired,
	visibleCount: PropTypes.number.isRequired,
	onRunNow: PropTypes.func.isRequired,
	isRunning: PropTypes.bool,
	canRunNow: PropTypes.bool,
}

/**
 * PropTypes for Integrity view.
 * No external props are expected; kept for consistency across view definitions.
 */
export const integrityViewPropTypes = {}
